import client from '../axios';
import { post } from '../service';

export const login = async (password) => {
  const response = await client.post('/admin/login', {
    password,
  });

  if (response.status === 200) {
    const responseData = response.data;
    return responseData;
  }

  throw new Error('Login failed');
};

export const changePassword = async (payload) => {
  const response = await post('/admin/change-password', payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};
